
import React, { useEffect, useState, useMemo } from 'react';
import { Switch, Input, ExpandableText, Form, Button, Tag, Select, Row, Col, Modal, message, ProTableOt, useProTableOt, Tabs, Skeleton, Popconfirm, ImportButton, Radio, DatePicker } from '../ui/ot'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import { useRef } from 'react';
import styled from "styled-components"
import { useStaffStatisticsGender } from './controllers/staff_statistics_gender_controller'
import { useStaffStatisticsDepartment } from './controllers/staff_statistics_department_controller'
import { useStaffStatisticsRole } from './controllers/staff_statistics_role_controller'
import { useGender } from './controllers/gender_controller'
import { useStaff } from './controllers/staff_controller'
import { useDepartment } from './controllers/department_controller'
import { useDepartmentDepth } from './controllers/department_depth_controller'
import RoleDepartment from './components/role_department';
import { createContext } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import BindLineId from '../login/BindLineId';
import { PropertyJson } from './DepartmentRoleManagement';
import { useCRUDController } from "../ui/classify_structure/CRUDController";
import { PermissionListModal } from '../permission_management/permission_list';
import throttle from 'lodash/throttle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import { usePersonalInformationManagementController } from './controllers/personal_information_management_controller'
import { CopyOutlined } from '@ant-design/icons';
import { useRoleDepartmentFormController, RoleDepartmentForm } from './components/role_department_form_controller'
import dayjs from 'dayjs'
const LanguageContext = createContext(null)
const Staff = ({
    keyPrefix = "organization_structure.staff",
    onSelect = () => { },
    toolBarRender = (tools) => ([...tools]),
    show_tab_bar = true,
    show_chart = false,
    departmentOnly = false,
    customFormItems = () => { }, //上層可加入自定義的form item 
    staffApi = "/queue_management/backend/staff_queue_mgnt" + (departmentOnly ? '_department' : ''), //staff 的api 名稱
    departmentApi = '/queue_management/backend/department_queue_mgnt',//department 的api 名稱
    customColumns = [], //列表編輯模式的顯示columns
    defaultSelectedKeys = [],
    defaultSelectedInfo = [],
    readonly = false,
    departmentMode = "department",
    propsShowKeys = [
        { key: "staff_serial_name", name: "staff_serial_name", hidden: false, require: false },
        { key: "user_department_role_data", name: "user_department_role_data", hidden: false, require: false },
        { key: "staff_name", name: "staff_name", hidden: false, require: true },
        { key: "staff_english_name", name: "staff_english_name", hidden: false, require: false },
        { key: "gender_name", name: "gender_name", hidden: false, require: false },
        { key: "staff_phone", name: "staff_phone", hidden: false, require: false },
        { key: "email", name: "email", hidden: false, require: false },
        { key: "address", name: "address", hidden: false, require: false },
        { key: "birthday", name: "birthday", hidden: false, require: false },
        { key: "county_and_city_district_num", name: "county_and_city_district_num", hidden: false, require: false },
        { key: "property_json", name: "property_json", hidden: false, require: false },
        { key: "create_user_name", name: "create_user_name", hidden: false, require: false },
        { key: "create_time", name: "create_time", hidden: false, require: true },
        { key: "last_edit_user_name", name: "last_edit_user_name", hidden: false, require: false },
        { key: "last_edit_time", name: "last_edit_time", hidden: false, require: false },
        { key: "employment_time_end", name: "employment_time_end", hidden: false, require: false },
        { key: "staff_queue_mgnt_staff_data", name: "staff_queue_mgnt_staff_data", hidden: false, require: false },
    ],
    propsRowSelectionType = 'checkbox',
    propsPatchProcess = () => { },
    propsInitialValues = {},
    propsReloadCount,
    propsReloadAndResetCount,
    propsSearchParams,
    onSearchParamsChange = () => { },
    searchParamsChangeToSearch = true

}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef(null)
    const currentUserId = useRef(null)
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedKeys)
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedInfo)
    const [extra_columns, set_extra_columns] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [modalOpen, setModalOpen] = useState(false);
    const [permissionModalOpen, setPermissionModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false)
    const [loading, setLoading] = useState(true)
    const [axiosMode, setAxiosMode] = useState("get")
    const [selectDepartmentId, setSelectDepartmentId] = useState();
    const [selectRoleId, setSelectRoleId] = useState();

    const [importData, setImportData] = useState([]);
    const [import_modal, set_import_modal] = useState(false);
    const [upload_modal, set_upload_modal] = useState(false)

    const [valuesModalVisible, setValuesModalVisible] = useState(false);
    const [valuesData, setValuesData] = useState(null);
    const [searchParams, setSearchParams] = useState(null);

    const tabDepartmentId = useRef(undefined)
    const departmentId = useRef()
    const roleId = useRef()
    const defaultColumns = [
        {
            title: '編號(系統帳號)',
            key: 'staff_serial_name',
            dataIndex: 'staff_serial_name',
            align: 'center',
        },
        ...(departmentMode === "department" ? [{
            title: '單位 - 職稱',
            key: 'user_department_role_data',
            dataIndex: 'user_department_role_data',
            align: 'left',
            render: (text, record) => (
                <Row>
                    {record.user_department_role_data && record.user_department_role_data.map((item) => (
                        <Col span={24}><Tag color="geekblue">
                            {
                                item?.department_name_language_data !== undefined
                                    ? (item?.role_name_language_data !== undefined
                                        ? (item?.department_name_language_data[0]?.language_culture_value + ' - ' + item?.role_name_language_data[0]?.language_culture_value)
                                        : item?.department_name_language_data[0]?.language_culture_value)
                                    : ''
                            }
                        </Tag></Col>
                    ))}
                </Row>
            )
        }] : []),
        ...(departmentMode === "structure" ? [{
            title: t('system_role'),
            key: 'user_department_role_data',
            dataIndex: 'user_department_role_data',
            align: 'left',
            render: (text, record) => (
                <Row>
                    {record.user_department_role_data && record.user_department_role_data.map((item) => (<>
                        <Col>
                            <Tag color="geekblue">
                                {
                                    item?.role_name_language_data?.[0]?.language_culture_value ?? ''
                                }
                                {item?.user_role_department_data && <>
                                    －
                                    {item?.user_role_department_data?.map(itemItem => itemItem?.department_language_data?.[0]?.language_culture_value ?? '').join('、')}
                                </>}
                            </Tag>
                        </Col>
                        <Col>
                            <Row>
                            </Row>
                        </Col>
                    </>))}
                </Row>
            )
        }] : []),
        {
            title: '姓名',
            key: 'staff_name',
            dataIndex: 'staff_name',
            align: 'center',
        },
        {
            title: '英文名',
            key: 'staff_english_name',
            dataIndex: 'staff_english_name',
            align: 'center',
        },
        {
            title: '性別',
            key: 'gender_name',
            dataIndex: 'gender_name',
            align: 'center',
        },

        {
            title: '電話',
            key: 'staff_phone',
            dataIndex: 'staff_phone',
            align: 'left',
        },
        {
            title: 'Email',
            key: 'email',
            dataIndex: 'email',
            align: 'left',
            render: (text) => (
                <Row>
                    <ExpandableText text={text} maxLines={1} />
                </Row>
            )
        },

        {
            title: '地址',
            key: 'address',
            dataIndex: 'address',
            align: 'left',
        },
        {
            title: '郵遞區號',
            key: 'county_and_city_district_num',
            dataIndex: 'county_and_city_district_num',
            align: 'left',
        },
        {
            title: '更多資訊',
            key: 'property_json',
            dataIndex: 'property_json',
            align: 'center',
            render: (text) => <>
                <Row>
                    {Object.keys(text).map(item => <Col span={24}>{item}：{text[item]}</Col>)}
                </Row>
            </>
        },
        {
            title: '卡號',
            key: 'rfid_code_arr',
            dataIndex: 'rfid_code_arr',
            align: 'center',
            render: (text, record) => <>
                <Row>
                    {record?.user_external_token_data?.find(_ => true)?.rfid_code_arr?.map(item => <Col span={24}>RFID：{item}</Col>)}
                </Row>
            </>
        },
        ...customColumns,
        {
            title: '建立人',
            key: 'create_user_name',
            dataIndex: 'create_user_name',
            align: 'center',
        },
        {
            title: '建立時間',
            key: 'create_time',
            dataIndex: 'create_time',
            align: 'center',
        },
        {
            title: '最後編輯人',
            key: 'last_edit_user_name',
            dataIndex: 'last_edit_user_name',
            align: 'center',
        },
        {
            title: '最後編輯時間',
            key: 'last_edit_time',
            dataIndex: 'last_edit_time',
            align: 'center',
        },
        {
            title: '有效日',
            key: 'employment_time_end',
            dataIndex: 'employment_time_end',
            align: 'center',
        },
        {
            title: '自動寫入卡機',
            key: 'staff_queue_mgnt_staff_data',
            dataIndex: 'staff_queue_mgnt_staff_data',
            align: 'center',
            render: (text, record) => <>
                <Row>
                    {record?.staff_queue_mgnt_staff_data?.find(_ => true)?.auto_in_card_machine == '1' ? <Col span={24}>是</Col> : <Col span={24}>否</Col>}
                </Row>
            </>
        },
    ]
    const [default_column, set_default_column] = useState([...defaultColumns.filter(column => propsShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true && !keyObj.formOnly))]);

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value) => {
                    select_temp.push(value.staff_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value) => {
                    const index = select_temp.indexOf(value.staff_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.staff_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.staff_id)
                selectRow = selectRow.filter(row => row.staff_id !== record.staff_id)
            }
            console.log('select_temp', select_temp)
            console.log('selectRow', selectRow)

            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: () => ({
            // disabled: record.pass === null,
        }),
    };
    const onFinish = ({ axiosMode, status, values, type }) => {
        if (status === "success") {
            if (axiosMode === "get") {
                return
            }
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                if (type === "reset_password") {
                    setValuesData(values); // 設置 values 資料
                    // console.log("設定 valuesData:", values);
                    setValuesModalVisible(true); // 打開視窗
                }
                // console.log("設定 Modal 開啟:", valuesModalVisible); // 確認狀態變化
                message.success("修改成功");
                actionRef.current.reload();
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            else if (axiosMode === "import") {
                message.success("匯入成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reload();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "import") {
                message.error("匯入失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = () => {
        setModalLoading(true)
    }

    const personalInformationController = useCRUDController({ onBefore, onFinish, apiRoute: staffApi });
    // const departmentController = useCRUDController({ onBefore, onFinish, apiRoute: departmentApi });
    const departmentController = useCRUDController({ onBefore, onFinish, apiRoute: departmentApi + "_dropdown" });
    const departmentOptionController = useCRUDController({ onBefore, onFinish, apiRoute: departmentApi });
    const resetPasswordController = usePersonalInformationManagementController({ onBefore, onFinish: (e) => onFinish({ ...e, type: 'reset_password' }), apiRoute: "/organization_structure/api/user/reset_password" });
    const { form, getFormValues } = useRoleDepartmentFormController({})
    const departmentAndRoleWatchedFields = form.watch(); // 會監聽RoleDepartment所有欄位

    const roleController = useCRUDController({
        apiRoute: '/queue_management/backend/role_queue_mgnt'
    })
    const roleOptionController = useCRUDController({
        apiRoute: '/queue_management/backend/role_queue_mgnt'
    })

    useEffect(() => {
        roleController.getData({
            all: true,
            classify_structure_type_id: 0,
            classify_structure_id: 8
        })
        roleOptionController.getData({
            all: true,
        })

        departmentController.getData({
            classify_structure_type_id: 0,
            classify_structure_id: 9
        }).finally(() => {
            setLoading(false)
        })
        departmentOptionController.getData({
            all: true
        })
    }, [])


    // useEffect(() => {
    //     console.log("Modal 開啟狀態變更:", valuesModalVisible);
    // }, [valuesModalVisible]);

    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [selectDepartmentId, selectRoleId])

    const changeDepartmentRole = (departmentRoleDataTemp) => {
        let departmentRoleDataResult = []
        departmentRoleDataResult = departmentRoleDataTemp.map((item) => {
            let departmentId = undefined
            let roleId = undefined
            departmentId = item.department_id
            roleId = item.role_id
            return (
                {
                    department_id: departmentId,
                    role_id: roleId,
                    ...(item?.user_role_department_data ? {
                        user_role_department_data: changeDepartmentRole(item?.user_role_department_data)
                    } : {})
                }
            )
        })
        return departmentRoleDataResult;
    }

    const changeData = (record) => {
        let data_tmp = importData.filter(item => item.index != record.index);
        setImportData(data_tmp);
    }

    const {
        getStaffStatisticsGenderData
    } = useStaffStatisticsGender({})

    const {
        getStaffStatisticsDepartmentData
    } = useStaffStatisticsDepartment({})

    const {
        getStaffStatisticsRoleData
    } = useStaffStatisticsRole({})

    const {
        DepartmentData } = useDepartment({})

    const {
        getDepartmentDepthData
    } = useDepartmentDepth({
        onBefore: () => {
            setLoading(true)
        },
        onFinish: ({ values }) => {
            let columns = [];
            values?.forEach(departmentDepth => {
                Object.entries(departmentDepth?.property_json)?.forEach(([property_json_key]) => {
                    columns.push({
                        title: property_json_key,
                        key: property_json_key,
                        dataIndex: property_json_key,
                        render: (text, record) => <>
                            {/* 拿個人部門 */}
                            {record?.user_department_role_data?.map(item => <>
                                {/* 篩選層級 */}
                                {item?.all_department_data?.filter(itemItem => itemItem?.depth === departmentDepth?.depth_id).map(itemItem => <>
                                    {/* 篩選屬性 */}
                                    <Row>
                                        <Col span={24}>
                                            <Tag color="geekblue">
                                                {itemItem?.property_json?.[property_json_key]}
                                            </Tag>
                                        </Col>
                                    </Row>
                                </>)}
                            </>)}
                        </>
                    })
                })
                columns.push({
                    title: departmentDepth?.depth_name,
                    key: departmentDepth?.depth_name,
                    dataIndex: departmentDepth?.depth_name,
                    render: (text, record) => <>
                        {/* 拿個人部門 */}
                        {record?.user_department_role_data?.map(item => <>
                            {/* 篩選層級 */}
                            {item?.all_department_data?.filter(itemItem => itemItem?.depth === departmentDepth?.depth_id).map(itemItem => <>
                                {/* 篩選語言 */}
                                {itemItem?.department_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem => <>
                                    <Row>
                                        <Col span={24}>
                                            <Tag color="geekblue">
                                                {itemItemItem?.language_culture_value}
                                            </Tag>
                                        </Col>
                                    </Row>
                                </>)}
                            </>)}
                        </>)}
                    </>
                })
                // })
                // columns.push({
                //     title: departmentDepth?.depth_name,
                //     key: departmentDepth?.depth_name,
                //     dataIndex: departmentDepth?.depth_name,
                // })
            })
            set_default_column([
                ...columns,
                ...defaultColumns
            ])

        }
    })

    const rowSelectionConfig = useMemo(() => ({
        type: propsRowSelectionType,
        selectedRowKeys,
        setSelectedRowKeys,
        selectedRowsInfo,
        setSelectedRowsInfo,
        ...rowSelection,
    }), [selectedRowKeys, selectedRowsInfo, rowSelection]);

    const throttledRequest = throttle(async (params, sort) => {
        const { role_id_arr, department_id_arr } = getFormValues(departmentOptionController);
        let newParams = {
            department_id_arr: department_id_arr.length === 0 ? undefined : `{${department_id_arr.join(',')}}`,
            role_id_arr_only: role_id_arr.length === 0 ? undefined : `{${role_id_arr.join(',')}}`,
        };
        let order = setOrders(sort)
        newParams = {
            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
            ...newParams,
            order,
            size: params.pageSize,
            cur_page: params.current,
            custom_filter_value: params.keyword ?? "",
            custom_filter_key: custom_filter_key,
            role_id_arr: roleId.current,
            all: true
        };
        newParams = setParamsFilter({
            ...newParams,
        });
        setPageSize(params?.pageSize ?? 20)

        return personalInformationController.getData({
            ...newParams
        }, {
            useCancelToken: false
        })
    }, 300); // 每 300ms 最多執行一次


    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns: default_column.concat(extra_columns || [])
    })


    const changeFormData = (data) => {
        let resultData = []
        resultData = data.map((item) => {
            let departmentRoleData = []
            if (item.user_department_role_data) {
                departmentRoleData = changeDepartmentRole(item.user_department_role_data)
            }
            return {
                ...item,
                "serial_name": item?.staff_serial_name,
                "name": item?.staff_name,
                "user_language_data": departmentRoleData
            }
        })
        return resultData
    }

    useEffect(() => {
        checkAll()
        // personalInformationController.getData()
        // getStaffStatisticsGenderData()
        // getStaffStatisticsDepartmentData()
        // getStaffStatisticsRoleData()
        // departmentController.getData({ classify_structure_type_id: 0, classify_structure_id: 9 })
    }, [])

    useEffect(() => {
        onSelect(selectedRowsInfo, selectedRowKeys)
    }, [selectedRowsInfo])
    useEffect(() => {
        if (!!propsReloadCount) {
            actionRef.current.reload()
        }
    }, [propsReloadCount])
    useEffect(() => {
        if (!!propsReloadAndResetCount) {
            actionRef.current.reloadAndRest()
        }
    }, [propsReloadAndResetCount])

    // 如果 propsSearchParams || searchParams 有變動要回傳給上層
    useEffect(() => {
        onSearchParamsChange({
            ...propsSearchParams,
            ...searchParams,
        })
        if (!!searchParamsChangeToSearch) {
            actionRef.current.onTableSearch()
        }
    }, [propsSearchParams, searchParams])

    // 如果role department 有變動 就變更 searchParams
    useEffect(() => {
        const { role_id_arr, department_id_arr } = getFormValues(departmentOptionController);
        setSearchParams((pre) => {
            if (
                JSON.stringify(pre?.role_id_arr) === JSON.stringify(role_id_arr) &&
                JSON.stringify(pre?.department_id_arr) === JSON.stringify(department_id_arr)
            ) {
                return pre;
            }

            return {
                ...pre,
                role_id_arr,
                department_id_arr
            };
        });
    }, [departmentAndRoleWatchedFields])
    return (<>
        <Modal
            title="新密碼"
            open={valuesModalVisible}
            onOk={() => setValuesModalVisible(false)} // 確認關閉視窗
            onCancel={() => setValuesModalVisible(false)} // 取消關閉視窗
            footer={[
                <Button
                    key="copy"
                    icon={<CopyOutlined />}
                    onClick={() => {
                        navigator.clipboard.writeText(valuesData);
                        message.success("已複製到剪貼簿");
                    }}
                >
                    複製
                </Button>,
                <Button key="confirm" type="primary" onClick={() => setValuesModalVisible(false)}>
                    確認
                </Button>,
            ]}
        >
            <pre
                style={{
                    background: '#f5f5f5',
                    padding: '10px',
                    borderRadius: '5px',
                    maxHeight: '300px',
                    overflow: 'auto',
                }}
            >
                {valuesData}
            </pre>
        </Modal>
        <LanguageContext.Provider vlaue={keyPrefix}>
        </LanguageContext.Provider>
        {show_tab_bar ?
            <Row>
                <Col>
                    <Tabs
                        items={[
                            {
                                key: undefined,
                                tab: '全部'
                            },
                            ...DepartmentData.map(item =>
                            (
                                {
                                    key: item.department_id,
                                    tab: item.department_language_data?.find(item => item.language_culture_code === "zh-tw")?.language_culture_value || item.title
                                }
                            )
                            )]}
                        onChange={(departmentId) => {
                            tabDepartmentId.current = departmentId
                            if (departmentId === undefined) {
                                getDepartmentDepthData({ department_id: 0 })
                            } else {
                                getDepartmentDepthData({ department_id: departmentId })
                            }
                        }}
                    />
                </Col>
            </Row>
            : <></>}
        {show_chart ?
            <Row>
                <Col span={24}>
                    <BasicDataStats></BasicDataStats>
                </Col>
            </Row>
            : <></>}
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <WhiteBox>
                    {loading && <Skeleton />}
                    {!loading && <>
                        <PermissionListModal propsOpen={permissionModalOpen} propsSetOpen={setPermissionModalOpen} id={currentUserId.current} prefix={'user'} apiRoute={'/organization_structure/api/staff_diverge'} />
                        <RoleDepartmentForm propsForm={form} propsStaffDepartmentDropdown={departmentOnly ? true : undefined} propsRole={false} propsDepartmentController={departmentController} />

                    </>}
                    <ProTableOt
                        searchParams={{
                            ...searchParams,
                            ...propsSearchParams,
                        }}
                        actionRef={actionRef}
                        columns={default_column}
                        check={check}
                        setCheck={setCheck}
                        rowKey={'staff_id'}
                        request={async (params = {}, sort, filter) => {
                            const { role_id_arr, department_id_arr } = getFormValues(departmentOptionController);
                            let newParams = {
                                ...propsSearchParams,
                                department_id_arr: department_id_arr.length === 0 ? undefined : `{${department_id_arr.join(',')}}`,
                                role_id_arr_only: role_id_arr.length === 0 ? undefined : `{${role_id_arr.join(',')}}`,
                            };
                            let order = setOrders(sort)
                            newParams = {
                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                ...newParams,
                                order,
                                size: params.pageSize,
                                cur_page: params.current,
                                custom_filter_value: params.keyword ?? "",
                                custom_filter_key: custom_filter_key,
                                role_id_arr: roleId.current,
                                all: true
                            };
                            newParams = setParamsFilter({
                                ...newParams,
                            });
                            setPageSize(params?.pageSize ?? 20)
                            return personalInformationController.getData({
                                ...newParams
                            }, {
                                useCancelToken: true
                            })
                        }}
                        // request={async (params = {}, sort, filter) => throttledRequest(params, sort, filter)}
                        propsPost={!readonly && true}
                        propsPatch={!readonly && true}
                        propsDelete={!readonly && true}
                        extraActionRender={(record) => <>
                            <Col span={24}>
                                <Row gutter={[8, 8]}>
                                    <Col>
                                        <Popconfirm
                                            title="重設密碼"
                                            description="確定重設密碼嗎？"
                                            onConfirm={() => resetPasswordController.patchData([{ 'user_id': record?.user_id }])}
                                            onCancel={() => { }}
                                        >
                                            <Button
                                                type="primary"
                                                style={{
                                                    backgroundColor: "#7FA1C3",
                                                }}
                                            >
                                                重設密碼
                                            </Button>
                                        </Popconfirm>
                                    </Col>
                                    {!departmentOnly && <Col>
                                        <Button
                                            style={{
                                                color: '#000000',
                                                backgroundColor: "#E2DAD6",
                                            }}
                                            onClick={() => {
                                                currentUserId.current = record?.user_id
                                                setPermissionModalOpen(true)
                                            }}>
                                            統一權限設定
                                        </Button>
                                    </Col>}
                                </Row>
                            </Col>
                        </>}
                        toolBarRender={() => toolBarRender([
                            !readonly &&
                            <Button className='example' style={{ background: '#1565C0', color: '#ffffff' }} onClick={() => personalInformationController.exportData({ 'staff_id_arr': selectedRowKeys })}>
                                匯出資料 <FontAwesomeIcon icon={faFileExport} style={{ marginLeft: '2px' }} />
                            </Button>,
                            !readonly &&
                            <ImportButton
                                handleDownload={(e) => personalInformationController.downloadData(e)}
                                handleImport={e => {
                                    e['columns'] = default_column.concat(extra_columns || []); personalInformationController.importData(e)
                                    set_upload_modal(false)
                                    set_import_modal(false)
                                }}
                                set_upload_modal={set_upload_modal}
                                upload_modal={upload_modal}
                                importData={importData}
                                setImportData={setImportData}
                                import_modal={import_modal}
                                set_import_modal={set_import_modal}
                                handleReserve={e => personalInformationController.patchData(e)}
                                handleOver={e => personalInformationController.overData(e)}
                                columns={[...default_column.concat(extra_columns || []), {
                                    title: '保留/覆蓋',
                                    align: 'center',
                                    render: (text, record) => {
                                        if (record.type == 'name') {
                                            return (
                                                <>
                                                    <Button type="text" style={{ color: '#4CAF50' }} onClick={() => { changeData(record) }}>保留</Button>
                                                </>)
                                        } else if (record.type == 'both') {
                                            return (
                                                <>
                                                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={() => { personalInformationController.patchData([record]); changeData(record) }}>覆蓋</Button>
                                                </>
                                            )
                                        }
                                    }
                                }]}
                            />,
                        ])}
                        rowSelection={rowSelectionConfig}

                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        manage_columns={true}
                        scroll={{ x: 'max-content' }}
                        propsPatchProcess={(record) => {
                            let newRecord = record
                            if (propsPatchProcess(record)) {
                                newRecord = propsPatchProcess(record)
                            }
                            return {
                                ...newRecord,
                                employment_time_end: newRecord?.employment_time_end ? dayjs(newRecord?.employment_time_end).format("YYYY-MM-DD") : null

                            }
                        }}
                        propsUseData={() => {
                            return {
                                postData: (data) =>
                                    personalInformationController.postData(changeFormData(data))
                                ,
                                patchData: (data) =>
                                    personalInformationController.patchData(changeFormData(data))
                                ,
                                deleteData: personalInformationController.deleteData,
                            }
                        }}
                        PropsPatchForm={<StaffForm
                            keyPrefix={keyPrefix}
                            customFormItems={customFormItems}
                            axiosMode={axiosMode}
                            // onFormFinish={onFormFinish}
                            departmentMode={departmentMode}
                            propsShowKeys={propsShowKeys}
                            formMode
                            propsRoleController={roleController}
                            propsRoleOptionController={roleOptionController}
                            propsDepartmentController={departmentController}
                            propsDepartmentOptionController={departmentOptionController}
                        />}
                        modalOpen={modalOpen}
                        setModalOpen={setModalOpen}
                        propsWidth={1000}
                        manageColumnsButton={!readonly && true}
                        pageSize={pageSize}
                        formMode
                        initialValues={{
                            serial_name_check: true,
                            ...propsInitialValues
                        }}
                        propsPostPatchMulti={false}
                    />
                </WhiteBox>
            </Col>
        </Row>
    </>)
}
export default Staff;

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}

const WhiteBox = styled.div`
                background-color: #fff;
                padding: 1em;
                width: 100%;
                `

const StaffForm = ({
    mode = "modal",
    keyPrefix = "organization_structure.staff",
    /* 欄位標籤前置位置 */
    propsForm,
    /* 是否為parent物件控制form */
    formReloadCount = 0,
    /* 強制刷新的變數 */
    onFormFinish = () => { },
    /* 送出表單後的事件 */
    field,
    staff_id,
    defaultValue,
    customFormItems = () => { },
    propsOnValuesChange = () => { },
    departmentMode = "department",
    departmentApi = '/organization_structure/api/department',//department 的api 名稱
    propsShowKeys = [
    ],
    genderOption = "select",
    formMode = false,
    formOnValuesChange = () => { },
    propsRoleController,
    propsRoleOptionController,
    propsDepartmentController,
    propsDepartmentOptionController,
    ...props
}) => {
    const [columnRequires, setColumnRequires] = useState([])
    const [chagePassword, setChagePassword] = useState(false)
    const [chageFrom, setChageFrom] = useState(true);

    const [count, setCount] = useState(0);
    const [form_] = Form.useForm();
    const form = propsForm || form_
    const currentKey = propsShowKeys
    /* 表單物件宣告 */
    const keyPrefix_ = useContext(LanguageContext);
    /* 欄位標籤前置位置 */
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    /* 初始化語言呈現的位置，依照預設標籤位置、也可以引入標籤位置 */
    const setDataInitialization = () => {
        /* 設定初始化時要執行的業務邏輯 */
        getGenderData()
        if (departmentOptionController?.ResponseData?.length === 0) {
            departmentOptionController.getData()
        }
        if (roleController?.ResponseData?.length === 0) {
            roleController.getData()
        }
    }

    const changeDepartmentRole = (departmentRoleDataTemp) => {
        let departmentRoleDataResult = []
        departmentRoleDataResult = departmentRoleDataTemp.map((item) => {
            let departmentId = undefined
            let roleId = undefined
            departmentOptionController.ResponseData.map((departmentDataItem) => {
                if (String(departmentDataItem.classify_structure_type_id) === String(item.department_classify_structure_type_id)) {
                    departmentId = departmentDataItem.department_id
                }
            })
            roleController.ResponseData.map((roleDataItem) => {
                if (String(roleDataItem.classify_structure_type_id) === String(item.role_classify_structure_type_id)) {
                    roleId = roleDataItem.role_id
                }
            })
            return (
                {
                    department_id: departmentId,
                    role_id: roleId,
                    ...(item?.user_role_department_data ? {
                        user_role_department_data: changeDepartmentRole(item?.user_role_department_data)
                    } : {})
                }
            )
        })
        return departmentRoleDataResult;
    }

    const onFinish = (values) => {
        let departmentRoleData = []
        if (values.user_department_role_data) {
            departmentRoleData = changeDepartmentRole(values.user_department_role_data)
        }
        /* form submit之後觸發事件 */
        onFormFinish({
            ...values,
            "serial_name": values?.staff_serial_name,
            "name": values?.staff_name,
            "user_language_data": departmentRoleData
        })
        /* 呼叫上層function */

    }
    const onValuesChange = (_, { name } = {}) => {
        /* 取得被改變的欄位 */
        let formValues = null
        /* 現有使用者輸入內容初始化 */
        if (propsForm) {
            /* 判斷form的物件來源 */
            formValues = propsForm.getFieldsValue()
            /* 現在取得使用者輸入內容 */
        }
        else {
            formValues = form.getFieldsValue()
            /* 現在取得使用者輸入內容 */
        }

        if (String(name).split('.').pop() === 'staff_serial_name') {
            const staff_serial_name = form.getFieldValue(name);
            if (/\s/.test(staff_serial_name)) {
                Modal.info({
                    title: '錯誤',
                    content: '請檢查 編號(系統帳號)，不可包含空白'
                })
            } else {
                form.setFieldValue([field?.name ?? '', "serial_name"].join('.'), staff_serial_name)
            }
        }
        if (formMode) {
            formOnValuesChange(_, { name }, form)
        }
        if (!formMode) {
            propsOnValuesChange(formValues)
        }
    }

    const { GenderData, getGenderData } = useGender({})

    useEffect(() => {
        setDataInitialization();
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    useEffect(() => {
        if (!formMode) {
            (propsForm ?? form).setFieldsValue({ ...defaultValue })
        }
    }, [defaultValue])

    useEffect(() => {
        setTimeout(() => {
            setCount(pre => pre + 1)
        }, 1000)
    }, [])

    const departmentOptionController_ = useCRUDController({ apiRoute: departmentApi });
    const departmentOptionController = propsDepartmentOptionController ?? departmentOptionController_

    const roleController_ = useCRUDController({ apiRoute: "/queue_management/backend/role_queue_mgnt" });
    const roleController = roleController_ ?? propsRoleOptionController

    const serial_name_check = Form.useWatch([field.name, 'serial_name_check'].join('.'), form)
    const user_id = Form.useWatch([field.name, 'user_id'].join('.'), form)
    return <>
        <Form
            form={form}
            name="question"
            initialValues={{
                remember: true
            }}
            onValuesChange={onValuesChange}
            onFinish={onFinish}
            // autoComplete="off"
            autoComplete="new-password"
        >
            {mode !== "information" && <>
                <Row gutter={[8, 8]}>
                    <Col xxl={mode === "modal" ? 24 : 12}
                        xl={mode === "modal" ? 24 : 12}
                        lg={mode === "modal" ? 24 : 12}
                        md={24}
                        sm={24}
                        xs={24}>
                        <Row gutter={[8, 8]}>
                            <Form.Item
                                name={[field?.name ?? '', "staff_id"]}
                                hidden
                            >
                            </Form.Item>
                            <Form.Item
                                name={[field?.name ?? '', "user_id"]}
                                hidden
                            >
                            </Form.Item>
                            <Form.Item
                                name={[field?.name ?? '', "serial_name"]}
                                hidden
                            >
                            </Form.Item>
                            <Form.Item
                                name={[field?.name ?? '', "staff_queue_mgnt_staff_data.0.staff_queue_mgnt_staff_id"]}
                                hidden
                            >
                            </Form.Item>
                            <Form.Item
                                name={[field?.name ?? '', "staff_queue_mgnt_staff_data.0.staff_queue_mgnt_id"]}
                                hidden
                            >
                            </Form.Item>
                            <Col span={18}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "staff_serial_name"
                                })?.hidden}
                            >
                                {chageFrom ? <Form.Item
                                    label={`身分證字號`}
                                    name={[field?.name ?? '', "staff_serial_name"]}
                                    {...(currentKey?.find((element) => {
                                        return element.name === "staff_serial_name"
                                    })?.require ? {
                                        rules: [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ]
                                    } : {})}
                                    labelCol={{ xs: 24, md: 11 }}
                                    wrapperCol={{ xs: 24, md: 13 }}
                                >
                                    {/* <Tag bordered={false} color="processing"> */}

                                    <Input bordered={false} disabled={props.edit ?? serial_name_check}>
                                    </Input>
                                    {/* </Tag> */}
                                </Form.Item>
                                    :
                                    <Form.Item
                                        label={`${t('passport_number')}`}
                                        name={[field?.name ?? '', "passport_number"]}
                                        {...(currentKey?.find((element) => {
                                            return element.name === "passport_number"
                                        })?.require ? {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "請輸入"
                                                }
                                            ]
                                        } : {})}
                                        labelCol={{ xs: 24, md: 11 }}
                                        wrapperCol={{ xs: 24, md: 13 }}
                                    >
                                        {/* <Tag bordered={false} color="processing"> */}

                                        <Input bordered={false} disabled={props.edit ?? serial_name_check}>
                                        </Input>
                                        {/* </Tag> */}
                                    </Form.Item>
                                }

                            </Col>
                            <Col span={6}>
                                <Form.Item
                                    name={[field?.name ?? '', "staff_serial_name_forigen"]}
                                >
                                    <Switch
                                        onChange={(res) => setChageFrom(!res.target.value)}
                                        checkedChildren="國外"
                                        unCheckedChildren="本國"
                                    />
                                </Form.Item>
                            </Col>
                            {user_id === undefined && <Col span={6}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "serial_name_check"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={'自動產生'}
                                    name={[field?.name ?? '', "serial_name_check"]}
                                    labelCol={12}
                                    wrapperCol={12}
                                >
                                    <Switch
                                        checkedChildren="是"
                                        unCheckedChildren="否"
                                    />
                                </Form.Item>
                            </Col>}
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "staff_name"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={"姓名"}
                                    name={[field?.name ?? '', "staff_name"]}
                                    {...(currentKey?.find((element) => {
                                        return element.name === "staff_name"
                                    })?.require ? {
                                        rules: [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ]
                                    } : {})}
                                    labelCol={{ xs: 24, md: 8 }}
                                    wrapperCol={{ xs: 24, md: 16 }}
                                >
                                    <Input>
                                    </Input>
                                </Form.Item>
                            </Col>
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "staff_english_name"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={"英文姓名"}
                                    name={[field?.name ?? '', "staff_english_name"]}
                                    {...(currentKey?.find((element) => {
                                        return element.name === "staff_english_name"
                                    })?.require ? {
                                        rules: [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ]
                                    } : {})}
                                    labelCol={{ xs: 24, md: 8 }}
                                    wrapperCol={{ xs: 24, md: 16 }}
                                >
                                    <Input>
                                    </Input>
                                </Form.Item>
                            </Col>
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "gender_id"
                                })?.hidden}
                            >
                                {genderOption === "select" && <Form.Item
                                    label={"性別"}
                                    name={[field?.name ?? '', "gender_id"]}
                                    {...(currentKey?.find((element) => {
                                        return element.name === "gender_id"
                                    })?.require ? {
                                        rules: [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ]
                                    } : {})}
                                    labelCol={{ xs: 24, md: 8 }}
                                    wrapperCol={{ xs: 24, md: 16 }}
                                >
                                    <Select
                                        options={GenderData.map((value) => {
                                            return {
                                                label: value.gender_name,
                                                value: String(value.gender_id)
                                            }
                                        })}
                                    >
                                    </Select>
                                </Form.Item>}
                                {genderOption === "radio" && <>
                                    <Form.Item
                                        label={"性別"}
                                        name={[field?.name ?? '', "gender_id"]}
                                        {...(currentKey?.find((element) => {
                                            return element.name === "gender_id"
                                        })?.require ? {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "請輸入"
                                                }
                                            ]
                                        } : {})}
                                        labelCol={{ xs: 24, md: 8 }}
                                        wrapperCol={{ xs: 24, md: 16 }}
                                    >
                                        <Radio.Group
                                        >
                                            <Row>
                                                {GenderData.map((value) => <Col xs={4} sm={3}><Radio value={value.gender_id}>{value.gender_name}</Radio></Col>)}
                                            </Row>
                                        </Radio.Group>
                                    </Form.Item>
                                </>}
                            </Col>
                            {!props.edit &&
                                <Col span={24}
                                    hidden={currentKey?.find((element) => {
                                        return element.name === "user_department_role_data"
                                    })?.hidden}
                                >
                                    <Form.Item
                                        hidden
                                        name={[field?.name ?? '', "user_department_role_data"]}
                                    ></Form.Item>
                                    <Form.List
                                        key={count}
                                        label={t('role')}
                                        name={[field?.name ?? '', "user_department_role_data"]}
                                        {...(currentKey?.find((element) => {
                                            return element.name === "user_department_role_data"
                                        })?.require ? {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "請輸入"
                                                }
                                            ]
                                        } : {})}
                                    >
                                        {(fields, { add, remove }) => (
                                            <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'end' }}>
                                                <Col span={16} >
                                                    <Button
                                                        style={{ width: '100%' }}
                                                        onClick={
                                                            () => {
                                                                add();
                                                            }
                                                        }>{departmentMode === "structure" ? t('add_role') : '新增部門'}</Button>
                                                </Col>
                                                {fields?.map((field_) => (<>
                                                    <Form.Item
                                                        hidden
                                                        name={[field_?.name ?? '', "user_role_id"]}
                                                    ></Form.Item>
                                                    <Col span={24}>
                                                        <Row className="mb-2" gutter={[8, 16]} align={"middle"}>
                                                            <Col span={8} className="text-right">{t('system_role')}：</Col>
                                                            <Col span={16}>
                                                                <Form.Item
                                                                    label={t('role')}
                                                                    name={[field_.name, 'role_id']}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: `此為必填項目`
                                                                        }
                                                                    ]}
                                                                >
                                                                    <RoleDepartment
                                                                        keyPrefix={keyPrefix}
                                                                        field={field_}
                                                                        propsForm={form}
                                                                        remove={remove}
                                                                        edit={false}
                                                                        propsRoleController={propsRoleController}
                                                                        propsRoleOptionController={propsRoleOptionController}
                                                                        propsDepartmentController={propsDepartmentController}
                                                                        propsDepartmentOptionController={propsDepartmentOptionController}
                                                                    ></RoleDepartment>
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </>))}
                                            </Row >
                                        )}
                                    </Form.List>
                                </Col>
                            }
                            <Col span={24}>
                                {customFormItems(field?.name, form.getFieldsValue(), onValuesChange, form, field)}
                            </Col>
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "staff_phone"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={"電話"}
                                    name={[field?.name ?? '', "staff_phone"]}
                                    {...(currentKey?.find((element) => {
                                        return element.name === "staff_phone"
                                    })?.require ? {
                                        rules: [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ]
                                    } : {})}
                                    labelCol={{ xs: 24, md: 8 }}
                                    wrapperCol={{ xs: 24, md: 16 }}
                                >
                                    <Input autocomplete="new-password" />
                                </Form.Item>
                            </Col>
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "email"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={"Email"}
                                    name={[field?.name ?? '', "email"]}
                                    {...(currentKey?.find((element) => {
                                        return element.name === "email"
                                    })?.require ? {
                                        rules: [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ]
                                    } : {})}
                                    labelCol={{ xs: 24, md: 8 }}
                                    wrapperCol={{ xs: 24, md: 16 }}
                                >
                                    <Input autocomplete="new-password" />
                                </Form.Item>
                            </Col>
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "custom_line_id"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={"Line ID"}
                                    name={[field?.name ?? '', "custom_line_id"]}
                                    {...(currentKey?.find((element) => {
                                        return element.name === "custom_line_id"
                                    })?.require ? {
                                        rules: [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ]
                                    } : {})}
                                    labelCol={{ xs: 24, md: 8 }}
                                    wrapperCol={{ xs: 24, md: 16 }}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "address"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={"地址"}
                                    name={[field?.name ?? '', "address"]}
                                    {...(currentKey?.find((element) => {
                                        return element.name === "address"
                                    })?.require ? {
                                        rules: [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ]
                                    } : {})}
                                    labelCol={{ xs: 24, md: 8 }}
                                    wrapperCol={{ xs: 24, md: 16 }}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "rfid_code_arr"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={"卡號反序"}
                                    name={[field?.name ?? '', "user_external_token_data.0.rfid_code_arr.0"]}
                                    labelCol={{ xs: 24, md: 8 }}
                                    wrapperCol={{ xs: 24, md: 16 }}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "employment_time_end"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={'有效日'}
                                    name={field?.name ?? '' ? [field?.name ?? '', "employment_time_end"].join('.') : "employment_time_end"}
                                    rules={[
                                        {
                                            required: currentKey?.find((element) => {
                                                return element.name === "employment_time_end"
                                            })?.require,
                                            message: "請輸入"
                                        }
                                    ]}
                                    labelCol={{ xs: 24, md: 8 }}
                                    wrapperCol={{ xs: 24, md: 16 }}
                                >
                                    <Input type="date" />
                                </Form.Item>
                            </Col>
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "birthday"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={'生日'}
                                    name={field?.name ?? '' ? [field?.name ?? '', "birthday"].join('.') : "birthday"}
                                    rules={[
                                        {
                                            required: currentKey?.find((element) => {
                                                return element.name === "birthday"
                                            })?.require,
                                            message: "請輸入"
                                        }
                                    ]}
                                    labelCol={{ xs: 24, md: 8 }}
                                    wrapperCol={{ xs: 24, md: 16 }}
                                >
                                    <Input type="date" />
                                </Form.Item>
                            </Col>
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "lunar_birthday"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={'農曆生日'}
                                    name={field?.name ?? '' ? [field?.name ?? '', "lunar_birthday"].join('.') : "lunar_birthday"}
                                    rules={[
                                        {
                                            required: currentKey?.find((element) => {
                                                return element.name === "lunar_birthday"
                                            })?.require,
                                            message: "請輸入"
                                        }
                                    ]}
                                    labelCol={{ xs: 24, md: 8 }}
                                    wrapperCol={{ xs: 24, md: 16 }}
                                >
                                    <Input type="date" />
                                </Form.Item>
                            </Col>
                            <Col span={24}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "auto_in_card_machine"
                                })?.hidden}
                            >
                                <Form.Item
                                    label={t('auto_in_card_machine')}
                                    name={[field?.name ?? '', "staff_queue_mgnt_staff_data.0.auto_in_card_machine"]}
                                    rules={[
                                        {
                                            required: currentKey?.find((element) => {
                                                return element.name === "auto_in_card_machine"
                                            })?.require,
                                            message: "請輸入"
                                        }
                                    ]}
                                >
                                    <Switch
                                        checkedChildren="是"
                                        unCheckedChildren="否"
                                        mode={"number"}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={mode === "modal" ? 0 : 12}
                        xl={mode === "modal" ? 0 : 12}
                        lg={mode === "modal" ? 0 : 12}
                        md={mode === "modal" ? 0 : 24}
                        sm={mode === "modal" ? 0 : 24}
                        xs={mode === "modal" ? 0 : 24}
                    >
                        {props.edit && <>
                            <Form.Item
                                label={"Line 綁定"}
                                name={"Line 綁定"}
                            >
                                <BindLineId />
                            </Form.Item>
                            <Form.Item
                                label={"修改密碼"}
                                name={[field?.name ?? '', "status"]}
                            >
                                <Switch onChange={(res) => setChagePassword(res)}
                                    checkedChildren={"開啟"}
                                    unCheckedChildren={"關閉"} />
                            </Form.Item>
                        </>}
                        {chagePassword && props.edit && <>
                            <Form.Item
                                label={"舊密碼"}
                                name={[field?.name ?? '', "old_password"]}
                                rules={[
                                    {
                                        required: true,
                                        message: `此為必填項目`
                                    }
                                ]}
                            >
                                <Input.Password autocomplete="new-password" />
                            </Form.Item>
                            <Form.Item
                                label={"修改密碼"}
                                name={[field?.name ?? '', "password"]}
                                rules={[
                                    {
                                        required: true,
                                        message: `此為必填項目`
                                    }
                                ]}
                            >
                                <Input.Password autocomplete="new-password" />
                            </Form.Item>
                            <Form.Item
                                label={"再次輸入"}
                                name={[field?.name ?? '', "password1"]}
                                dependencies={['password']}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: '請確認新密碼',
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('兩次密碼不相同'));
                                        },
                                    }),
                                ]}

                            >
                                <Input.Password autocomplete="new-password" />
                            </Form.Item>
                        </>}
                    </Col>
                </Row>
                {mode === "modal" && <>
                    {props.edit && <>
                        <Form.Item
                            label={"Line 綁定"}
                            name={"Line 綁定"}
                        >
                            <BindLineId />
                        </Form.Item>
                        <Form.Item
                            label={"修改密碼"}
                            name={[field?.name ?? '', "status"]}
                        >
                            <Switch onChange={(res) => setChagePassword(res)}
                                checkedChildren={"開啟"}
                                unCheckedChildren={"關閉"}
                            />
                        </Form.Item>
                    </>}
                    {chagePassword && props.edit && <>
                        <Form.Item
                            label={"舊密碼"}
                            name={[field?.name ?? '', "old_password"]}
                            rules={[
                                {
                                    required: true,
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input.Password autocomplete="new-password" />
                        </Form.Item>
                        <Form.Item
                            label={"修改密碼"}
                            name={[field?.name ?? '', "password"]}
                            rules={[
                                {
                                    required: true,
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input.Password autocomplete="new-password" />
                        </Form.Item>
                        <Form.Item
                            label={"再次輸入"}
                            name={[field?.name ?? '', "password1"]}
                            dependencies={['password']}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: '請確認新密碼',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('兩次密碼不相同'));
                                    },
                                }),
                            ]}

                        >
                            <Input.Password autocomplete="new-password" />
                        </Form.Item>
                    </>}
                    <Col span={24}
                        hidden={currentKey?.find((element) => {
                            return element.name === "property_json"
                        })?.hidden}
                    >
                        <Form.Item
                            name={[field?.name ?? '', "property_json"]}
                            {...(currentKey?.find((element) => {
                                return element.name === "property_json"
                            })?.require ? {
                                rules: [
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]
                            } : {})}
                        >
                            <PropertyJson />
                        </Form.Item>
                    </Col>
                </>}
            </>}
            {mode === "information" && <>
                <Form.Item
                    name={[field?.name ?? '', 'staff_id']}
                >
                    <StaffInformation
                        staff_id={staff_id}
                    />
                </Form.Item>
            </>}
        </Form>
    </>
}
export { StaffForm }

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);
const BasicDataStats = () => {
    // 模擬統計數據
    const totalUsers = 1000;
    const lineBoundUsers = 300;
    const qrCodeBoundUsers = 450;
    const unboundLineUsers = totalUsers - lineBoundUsers;
    const unboundQRCodeUsers = totalUsers - qrCodeBoundUsers;

    // Line 綁定與未綁定人數
    const lineChartData = {
        labels: ['已綁定', '未綁定'],
        datasets: [{
            label: 'Line 綁定狀況',
            data: [lineBoundUsers, unboundLineUsers],
            backgroundColor: ['rgba(54, 162, 235, 0.6)', 'rgba(255, 99, 132, 0.6)'],
            borderColor: ['rgba(54, 162, 235, 1)', 'rgba(255, 99, 132, 1)'],
            borderWidth: 1,
        }]
    };

    // QRCode 綁定與未綁定人數
    const qrCodeChartData = {
        labels: ['已綁定', '未綁定'],
        datasets: [{
            label: 'QRCode 綁定狀況',
            data: [qrCodeBoundUsers, unboundQRCodeUsers],
            backgroundColor: ['rgba(75, 192, 192, 0.6)', 'rgba(255, 159, 64, 0.6)'],
            borderColor: ['rgba(75, 192, 192, 1)', 'rgba(255, 159, 64, 1)'],
            borderWidth: 1,
        }]
    };

    // 總人數的條形圖
    const totalUsersChartData = {
        labels: ['總人數'],
        datasets: [{
            label: '基本資料維護總人數',
            data: [totalUsers],
            backgroundColor: 'rgba(153, 102, 255, 0.6)',
            borderColor: 'rgba(153, 102, 255, 1)',
            borderWidth: 1,
        }]
    };

    return (
        <Row>
            <Col
                xxl={8}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
            >
                <h3>基本資料維護總人數</h3>
                <Bar data={totalUsersChartData} />
            </Col>
            {/* Line 綁定人數 */}

            <Col
                xxl={8}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
            >
                <h3>Line 綁定人數</h3>
                <Pie data={lineChartData} />
            </Col>
            {/* QRCode 綁定人數 */}
            <Col
                xxl={8}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
            >
                <h3>QRCode 綁定人數</h3>
                <Pie data={qrCodeChartData} />
            </Col>
        </Row>
    );
}

const StaffInformation = ({
    staff_id,
    value }) => {
    const { StaffData, getStaffData } = useStaff({ onBefore: () => { }, onFinish: () => { } })
    useEffect(() => {
        getStaffData({
            staff_id: staff_id ?? value
        })
    }, [value, staff_id])
    const staff = StaffData?.find(_ => true) || {}
    return <>
        <FormContainer>
            <FormTitle>現在登入人員資訊</FormTitle>
            <FormField>
                <Label>姓名</Label>
                <Input type="text" value={staff?.staff_name} disabled />
            </FormField>
            <FormField>
                <Label>電子郵件</Label>
                <Input type="email" value={staff?.email} disabled />
            </FormField>
            <FormField>
                <Label>人員編號</Label>
                <Input type="text" value={staff?.serial_name} disabled />
            </FormField>
        </FormContainer>
    </>
}

// Styled Components
const FormContainer = styled.div`
                display: flex;
                flex-direction: column;
                max-width: 400px;
                margin: 50px auto;
                padding: 20px; 
                border: 1px solid #ccc;
                border-radius: 10px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                `;

const FormTitle = styled.h2`
                margin-bottom: 20px;
                text-align: center;
                color: #333;
                `;

const FormField = styled.div`
                margin-bottom: 15px;
                `;

const Label = styled.label`
                display: block;
                margin-bottom: 5px;
                font-weight: bold;
                color: #555;
                `;

